import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { Component } from "./TabPane.style";
import { ThemeProvider } from "styled-components";
import { theme } from "./../../theme";

class TabPane extends React.Component {
  render() {
    const { className, tabId, ...attributes } = this.props;
    const { activeItemId } = this.context;
    const classes = classNames(
      "tab-pane",
      { active: tabId === activeItemId },
      className
    );
    const activeId = tabId === activeItemId ? true : false;
    return (
      <ThemeProvider theme={theme}>
        <Component>
          <TransitionGroup>
            <CSSTransition
              timeout={300}
              key={tabId}
              in={activeId}
              appear={true}
              classNames="fade"
            >
              <div
                data-test="tab-pane"
                {...attributes}
                className={classes}
                role="tabpanel"
              />
            </CSSTransition>
          </TransitionGroup>
        </Component>
      </ThemeProvider>
    );
  }
}

TabPane.contextTypes = {
  activeItemId: PropTypes.any,
};

TabPane.propTypes = {
  className: PropTypes.string,
  tabId: PropTypes.any,
};

export default TabPane;
export { TabPane as CDBTabPane };
